<header #header [enableImpersonation]="true"
        brandImage="../../assets/common/header/logo-randstad.png"
        brandImageAlt="Randstad">
    <dashboard-menu menuSection [hidden]="!showKpis" [tabEntries]="tabEntries" [selectedOfficeIsRecruitment]="selectedOfficeIsRecruitment"></dashboard-menu>
    <dashboard-mobile-menu mobileMenuSection [hidden]="!showKpis" [tabEntries]="tabEntries" (onOptionSelected)="header.showMobileMenu=false"></dashboard-mobile-menu>
    <launcher-mobile mobileMenuSection></launcher-mobile>
    <office-selector userActions></office-selector>
    <div userActions style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: flex-end;">
      @if (impersonationEnabled) {
        <impersonation-menu></impersonation-menu>
      }

      <help [compactView]="impersonationEnabled"></help>
    </div>
</header>
<loading-overlay [show]="busy">
    <div class="container-fluid rs-container">
        <div class="row">
            <launcher></launcher>
            <div class="col-12 col-md-12 col-lg-12 col-xl-12 bd-content" style="max-width: 100%;" [hidden]="showKpis">
                <h1 style="font-size: 24px; font-weight: 500; text-align: center;">No existen indicadores que mostrar para esta oficina</h1>
            </div>
            <div class="col-12 col-md-12 col-lg-12 col-xl-12 bd-content" [hidden]="!showKpis || selectedOfficeIsRecruitment">
                <ng-template #dashboardItemContainer></ng-template>
            </div>
            <div class="col-12 col-md-12 col-lg-12 col-xl-12 bd-content" style="max-width: 100%;" [hidden]="!selectedOfficeIsRecruitment">

                <h1 style="font-size: 24px; font-weight: 500; text-align: center;" [hidden]="showDasboardRecruitment">Dashboard en construcción.</h1>

            </div>
        </div>
    </div>
</loading-overlay>
